<div class="photo-list-container" *ngIf="path">
    <label>{{this.options?.label || 'Selected Photos'}}</label>
    <div class="row">
        <ng-container *ngFor="let image of album; let i= index">
            <div class="selected-item {{options?.galleryItemCss || ''}}">
                <span class="icon" (click)="selectPhoto(i, true)">
                    <i [ngClass]="{
                        'fas': true,
                        'fa-check-square': true
                        }"></i>
                </span>
                <img [src]="image.thumb" class="img-fluid" (click)="openGallery(i)">
            </div>
        </ng-container>
    </div>
</div>


